import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getSwitches(relayId) {
        return axios.get(config.publicPath + 'pmta_relay_switches/' + relayId, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    updateSwitch(relayId, providerId, off) {
        let data = new FormData();
        data.append('off', off);
        return axios.post(config.publicPath + 'pmta_relay_switch/' + relayId + '/' + providerId, data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
    updateSwitches(relayId, switches) {
        let data = new FormData();
        data.append('switches', JSON.stringify(switches));
        return axios.post(config.publicPath + 'pmta_relay_switches/' + relayId, data, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            }
        });
    },
}
